import React from 'react';
import { Checkbox } from 'primereact/checkbox';
import { Trans } from 'react-i18next';
import { enumCategorieRecherche } from '../../enums/enumCategorieRecherche.js';

export const ContractTypeFilters = ({ lazyParams, onCheckChange, idSuffix = '' }) => {
    const contractTypes = [
        { id: 'ContratStage', category: enumCategorieRecherche.ContratStage, i18nKey: 'search.stage' },
        { id: 'ContratAltApp', category: enumCategorieRecherche.ContratAltApp, i18nKey: 'search.alt_app' },
        { id: 'ContratAltPro', category: enumCategorieRecherche.ContratAltPro, i18nKey: 'search.alt_pro' },
        { id: 'ContratCDDCDI', category: enumCategorieRecherche.ContratCDDCDI, i18nKey: 'search.cdd_cdi' },
        { id: 'ContratAutres', category: enumCategorieRecherche.ContratAutres, i18nKey: 'search.others' }
    ];

    return (
        <div className="container-global-domaines">
            {contractTypes.map(({ id, category, i18nKey }) => (
                <div key={id} className='field-checkbox dip-flex-row dip-ai-center'>
                    <Checkbox
                        inputId={`${id}${idSuffix}`}
                        className='msf-input-switch'
                        checked={lazyParams?.filters?.filter(o => o.categorie === category)[0]?.value || false}
                        onChange={(e) => onCheckChange(e.checked, category)}
                    />
                    <label htmlFor={`${id}${idSuffix}`} className="dip-flex-grow-1 msf-tab-title">
                        <Trans i18nKey={i18nKey} />
                    </label>
                </div>
            ))}
        </div>
    );
};
